/* ToeFix V6: reveal only supporting content as it enters the viewport.
   Deliberately excludes the primary product gallery, price and purchase CTA. */
(() => {
  'use strict';
  const root = document.getElementById('MainContent');
  if (!root || !root.dataset.template?.startsWith('product')) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selectors = [
    '.tf-blue-page .tf-section > .tf-wrap > *',
    '.tf-blue-page .tf-review-grid > .tf-review',
    '.tf-nail-page .tf-nail-section > .tf-nail-wrap > *',
    '.tf-nail-page .tf-nail-grid > .tf-nail-card',
    '.product-recommendations .section-resource-list__content',
  ];
  const seen = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '0px 0px 35px 0px', threshold: 0.08 });

  function setup(scope = root) {
    const nodes = scope.querySelectorAll(selectors.join(','));
    let count = 0;
    for (const node of nodes) {
      if (seen.has(node) || node.closest('[hidden]')) continue;
      seen.add(node);
      // No blank space on initial load, browser back, or when scrolling to an
      // anchor: anything already near the viewport is immediately visible.
      const rect = node.getBoundingClientRect();
      node.dataset.toefixReveal = '';
      if (rect.top < window.innerHeight * 0.92 || rect.bottom <= 0) {
        node.classList.add('is-visible');
      } else {
        node.style.setProperty('--toefix-reveal-delay', `${Math.min(count % 3, 2) * 65}ms`);
        observer.observe(node);
      }
      count++;
    }
    document.documentElement.classList.add('toefix-scroll-reveal-enabled');
  }

  try {
    setup();
    document.addEventListener('shopify:section:load', (event) => {
      if (root.contains(event.target)) setup(event.target);
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        for (const element of root.querySelectorAll('[data-toefix-reveal]')) {
          element.classList.add('is-visible');
          observer.unobserve(element);
        }
      }
    });
  } catch (error) {
    // Fail open: content must never remain invisible due to an animation error.
    document.documentElement.classList.remove('toefix-scroll-reveal-enabled');
    console.warn('ToeFix scroll reveal disabled:', error);
  }
})();
